import CSSOM from 'cssom';

const allowedCSSSelectors = ['.narvar', '#narvar'];

const filterCSSStyleRule = (cssText: string): string => {
  const { selectorText = '', style } = CSSOM.CSSStyleRule.parse(
    cssText,
  ) as CSSStyleRule;
  const allowed = allowedCSSSelectors.some(
    (allowedCSSSelector) => selectorText.indexOf(allowedCSSSelector) === 0,
  );
  return allowed ? `${selectorText} { ${style.cssText} } ` : '';
};

// Only keep CSS classes that start with one of the allowed css selectors
// to prevent global selectors from being passed
export default (style: string): string => {
  const { cssRules } = CSSOM.parse(style);
  return cssRules
    .map((cssRule: CSSOM.CSSRule) => {
      if (cssRule.type === CSSOM.CSSRule.MEDIA_RULE) {
        const {
          cssRules: cssMediaRules = [],
          media,
        }: {
          cssRules: CSSOM.CSSRule[];
          media: CSSOM.MediaList;
        } = cssRule as CSSOM.CSSMediaRule;
        const filteredMediaStyle = cssMediaRules
          .map((cssMediaQueryRule: CSSOM.CSSRule) =>
            filterCSSStyleRule(cssMediaQueryRule.cssText),
          )
          .join(' ');
        return filteredMediaStyle
          ? `@media ${media.mediaText} { ${filteredMediaStyle} } `
          : '';
      }
      return filterCSSStyleRule(cssRule.cssText);
    })
    .join(' ');
};
